var exports = {
  "kL": "SidebarShellSkeleton.module__container___c0pySz",
  "Kd": "SidebarShellSkeleton.module__containerMobile___c0pySz",
  "DF": "SidebarShellSkeleton.module__headerFrame___c0pySz",
  "VH": "SidebarShellSkeleton.module__headerFrameBanner___c0pySz",
  "kW": "SidebarShellSkeleton.module__headerBanner___c0pySz",
  "wx": "SidebarShellSkeleton.module__header___c0pySz",
  "D": "SidebarShellSkeleton.module__headerCaret___c0pySz",
  "Qs": "SidebarShellSkeleton.module__content___c0pySz",
};

module.exports = exports;
